import gql from 'graphql-tag'  //引入graphql
const apollo={
	tasks:gql`query tasks($cate: String!,$userId:String){
		tasks(cate:$cate,userId:$userId){
			name,
			id,
			assignTime,
			uri,
			process{
				id,
				name,
				uri,
				tags,
				entry,
				owner{
					id,
					name,
					account
				}
				app{
					name,
					system
				}
			}
		}
	}`,
	processes:gql`query processes($cate:String!,$userId:String,$page:Int,$size:Int){
		processes(cate:$cate,userId:$userId,page:$page,size:$size){
			total,
			processes{
				id,
			    name,
			    uri,
			    entry,
			    pendingTasks,
			    update,
			    app{
			    	name
			    }
			}
		}
	}`,
	guide:gql`query guide($first: Int,$offset: Int,$id: ID,$title: String,$stepTitle: String,$context: String,$keyword: String
	,$isRealease: Boolean,$state: Int,$appId: [String],$appTag: String,$appName: String,$appCode: [String]){
	    guide(first:$first,offset:$offset,id:$id,title:$title,stepTitle:$stepTitle,context:$context,keyword:$keyword
	,isRealease:$isRealease,state:$state,appId:$appId,appTag:$appTag,appName:$appName,appCode:$appCode){
	    totalCount
	    edges{
	      node{
	        id
	        title
	  		keyword
	  		mainpic
	  		isRealease
	 	 	createUser
	  		createUserAccount
	 	 	createTime
	  		updateTime
	  		updateUser
	  		updateUserAccount
	  		state
	  		guideStepList{
	          listId
	          context
	          guideId
	          stepNo
	          stepTitle
	          guideStepAppList{
	            listAppId
	            appId
	            appCode
	            appName
	            appTag
	            appUrl
	            guideId
	            guideStepId
	          }
	        }
	      }
	    }
	  }
	}`
}
export default apollo


// WEBPACK FOOTER //
// ./src/graphql/apollo.js